import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { TABLE_HEADER_BACKGROUND_COLOR } from '../../../constants/colors';
import { BannerEnum } from '../../../enums/bannerEnum';
import { useTranslation } from 'react-i18next';

interface Props {
  value: BannerEnum,
  onChange: (newValue: BannerEnum) => void
}

export default function TabPanelComponent({ value, onChange }: Props) {
  const { t } = useTranslation("global");

  return (
    <Box sx={{ width: '100%', backgroundColor: TABLE_HEADER_BACKGROUND_COLOR }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={(e: any, newValue: BannerEnum) => {
          onChange(newValue);
        }} variant="scrollable"
          scrollButtons="auto">
          <Tab label={t("banner_page.Landing")} value={BannerEnum.LANDING_PAGE} sx={{ textTransform: 'none' }} />
          <Tab label={t("banner_page.Delivery")} value={BannerEnum.DELIVERY} sx={{ textTransform: 'none' }} />
          {/* <Tab label={t("banner_page.Promotion flash sale")} value={BannerEnum.PROMOTION_FLASH_SALE} sx={{ textTransform: 'none' }} /> */}
          {/* <Tab label={t("banner_page.Category")} value={BannerEnum.CATEGORY} sx={{ textTransform: 'none' }} />
          <Tab label={t("banner_page.Product detail")} value={BannerEnum.PRODUCT_DETAIL} sx={{ textTransform: 'none' }} />
          <Tab label={t("banner_page.Pre order")} value={BannerEnum.PRE_ORDER} sx={{ textTransform: 'none' }} /> */}
          <Tab label={t("banner_page.Promotion")} value={BannerEnum.PROMOTION} sx={{ textTransform: 'none' }} />
          <Tab label={t("banner_page.Coupon")} value={BannerEnum.COUPON} sx={{ textTransform: 'none' }} />
        </Tabs>
      </Box>
    </Box>
  );
}
